{
  "userSelect": {
    "placeholder": "Sélectionner un utilisateur",
    "loading": "Chargement...",
    "noUsers": "Aucun utilisateur trouvé",
    "error": "Erreur lors du chargement des utilisateurs",
    "search": "Rechercher des utilisateurs...",
    "noResults": "Aucun utilisateur trouvé.",
    "allDepartments": "Tous les départements",
    "usersSelected": "{{count}} utilisateurs sélectionnés",
    "usersSelected_one": "{{count}} utilisateur sélectionné",
    "usersSelected_other": "{{count}} utilisateurs sélectionnés",
    "noManager": "Aucun responsable",
    "default": "Par défaut"
  },
  "departmentSelect": {
    "placeholder": "Sélectionner un département",
    "loading": "Chargement...",
    "noDepartments": "Aucun département trouvé",
    "error": "Erreur lors du chargement des départements",
    "search": "Rechercher des départements...",
    "noResults": "Aucun département trouvé.",
    "allDepartments": "Tous les départements",
    "noParentDepartment": "Aucun département parent"
  },
  "orgFunctionSelect": {
    "placeholder": "Sélectionner une Fonction",
    "loading": "Chargement...",
    "noOrgFunctions": "Aucune Fonction trouvée",
    "error": "Erreur lors du chargement des Fonctions",
    "search": "Rechercher des Fonctions...",
    "noResults": "Aucune Fonction trouvée.",
    "noOrgFunction": "Aucune Fonction"
  },
  "systemSelect": {
    "placeholder": "Sélectionner un système",
    "loading": "Chargement...",
    "noSystems": "Aucun système trouvé",
    "error": "Erreur lors du chargement des systèmes",
    "search": "Rechercher des systèmes...",
    "noResults": "Aucun système trouvé.",
    "noSystem": "Aucun système",
    "systemsSelected": "{{count}} sélectionnés"
  },
  "userTransferListbox": {
    "error": "Erreur lors du chargement des utilisateurs",
    "noUsers": "Aucun utilisateur disponible",
    "availableUsers": "Personnes disponibles",
    "selectedUsers": "Personnes sélectionnées",
    "searchUsers": "Rechercher des personnes…"
  },
  "surveyDialog": {
    "title": "Retour sur l'étape de processus",
    "description": "Vos retours aident à améliorer les processus. Veuillez nous indiquer comment vous percevez cette étape de processus.",
    "ratingQuestion": "Dans quelle mesure cette étape fonctionne-t-elle bien pour vous ?",
    "commentPlaceholder": "Partagez vos impressions sur cette étape de processus...",
    "frequencyQuestion": "À quelle fréquence effectuez-vous cette étape de processus ?",
    "frequencyPlaceholder": "Sélectionner la fréquence",
    "timesPerDayQuestion": "Combien de fois par jour ?",
    "timesPerWeekQuestion": "Combien de fois par semaine ?",
    "timesPerPeriodPlaceholder": "Saisir un nombre (ex. 5)",
    "durationQuestion": "Combien de temps dure cette étape en moyenne ? (en minutes)",
    "durationPlaceholder": "Saisir la durée en minutes (ex. 30)",
    "submit": "Soumettre le retour",
    "cancel": "Annuler",
    "recordedBy": "Enregistré par",
    "processStep": "Étape de processus",
    "ratingSection": "Votre retour",
    "metricsSection": "Effort et fréquence",
    "addCommentOptional": "Ajouter un commentaire",
    "variantQuestion": "Effectuez-vous cette étape exactement ainsi ?",
    "variantSame": "Oui, exactement ainsi",
    "variantSameDescription": "J'effectue l'étape exactement comme elle est décrite.",
    "variantDifferent": "Oui, mais différemment",
    "variantDifferentDescription": "J'effectue l'étape, mais à ma manière.",
    "variantNotPerformed": "Je n'effectue pas cette étape",
    "variantNotPerformedDescription": "Cette étape ne fait pas partie de mon travail.",
    "variantDescriptionQuestion": "Que faites-vous différemment ?",
    "variantDescriptionPlaceholder": "Décrivez en quoi votre façon de procéder diffère...",
    "closedTitle": "Cette enquête est terminée",
    "closedCompleted": "Vos réponses ont déjà été enregistrées.",
    "closedDismissed": "Vous avez indiqué que vous n'effectuez pas cette étape.",
    "closedNotApplicable": "Vous n'avez rien à répondre dans cette enquête."
  }
}
